// @flow
import env from '../../../environment';
import {
  getCreator,
  postCreator,
  putCreator,
  // putCreator,
  // deleteCreator,
} from '../../../http';

import type {PromotionType} from '../../../entities';

export type PromotionRequest = {
  description?: string,
  files?: boolean,
  mode?: 'ALL' | 'PRODUCT' | 'CATEGORY',
  name?: string,
  code?: string,
  discountPercentage?: number,
  products?: {productId: string}[],
  categories?: {categoryId: string}[],
  promotionType?: PromotionType | '',
  buy_ammount?: number,
  free_ammount?: number,
  minRequirement?: {
    minAmount?: number,
    minQuantity?: number,
  },
  // scope: 'PRODUCT' | 'SHIPPING',
  promotionImage?: File,
  promotionSmallImage?: File,
};

export const endpoints = Object.freeze({
  GET_PROMOTIONS: `${env.baseApiUrl}/im/admin/promotion`,
  GET_PROMOTION: `${env.baseApiUrl}/im/admin/promotion/:promotionId`,
  CREATE_PROMOTION: `${env.baseApiUrl}/im/admin/promotion`,
  EDIT_PROMOTION: `${env.baseApiUrl}/im/admin/promotion/:promotionId`,
  SORT_PROMOTION: `${env.baseApiUrl}/im/admin/promotion/sort`,
});

export const getPromotionsApi = getCreator(endpoints.GET_PROMOTIONS);
export const getPromotionApi = getCreator(endpoints.GET_PROMOTION);
export const editPromotionApi = putCreator(endpoints.EDIT_PROMOTION);
export const createPromotionApi = postCreator(endpoints.CREATE_PROMOTION);
export const sortPromotionApi = postCreator(endpoints.SORT_PROMOTION);
